<template>
  <div class="ec-page-bar clearfix">

    <el-col :span="24" class="ec-toolbar" >

      <el-pagination 
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :small = "small" 
      :total="total" 
      :pageCount="pageCount" 
      :pagerCount = "pagerCount" 
      :layout = "layout" 
      :pageSizes = "pageSizes"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange" 
      @prev-click="prevPage"
      @next-click="nextPage"
      >
      <el-button icon="el-icon-refresh"   @click="handleClick" >刷新</el-button> 
      </el-pagination>

    </el-col>
  </div>
</template>

<script >
export default {
  name: "EcPager",

  props: {
    //是否使用小型分页样式
    small: Boolean,
    //总条目数
    total: Number,
    //总页数，total 和 page-count 设置任意一个就可以达到显示页码的功能；如果要支持 page-sizes 的更改，则需要使用 total 属性
    pageCount: Number,
    //页码按钮的数量，当总页数超过该值时会折叠 大于等于 5 且小于等于 21 的奇数 默认值为7
    pagerCount: {
      type: Number
    },
    //当前页数，支持 .sync 修饰符
    page: {
      type: Number,
      default: 1
    },
    //每页显示条目个数，支持 .sync 修饰符
    limit: {
      type: Number,
      default: 10
    },

    //组件布局，子组件名用逗号分隔
    layout: {
      default: "total, sizes, prev, pager, next, jumper ,slot"
    },
    //是否为分页按钮添加背景色
    background: {
      type: Boolean,
      default: true
    },
    //每页显示个数选择器的选项设置,默认值[10, 15, 20, 30, 40, 50, 60, 70, 80, 90 ,100]
    pageSizes: {
      type: Array,
      default() {
        return [10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100];
      }
    }
  },

  components: {},

  computed: {
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        var _this = this;
        _this.$emit("update:limit", val);
      }
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        var _this = this;
        //更新当前页，
        _this.$emit("update:page", val);
      }
    }
  },

  methods: {
    handleClick() {
      var _this = this;
      _this.$emit("refresh-icon-click", {
        page: _this.currentPage,
        limit: _this.pageSize
      });
      _this.$emit("pagination", null, {
        page: _this.currentPage,
        limit: _this.pageSize
      });
    },

    handleSizeChange(value) {
      var _this = this;
      //此处由于pageSize没有自动计算，在此手动设置值
      _this.pageSize = value;
      _this.$emit("pagination", null, {
        page: _this.currentPage,
        limit: value
      });
      _this.$emit("size-change", value);
    },

    handleCurrentChange(value) {
      var _this = this;
      _this.setCurrentPage(value);
      _this.$emit("current-change", value);
    },

    prevPage(value) {
      var _this = this;
      _this.setCurrentPage(value);
      _this.$emit("prev-click", value);
    },
    nextPage(value) {
      var _this = this;
      _this.setCurrentPage(value);
      _this.$emit("next-click", value);
    },
    setCurrentPage(value) {
      var _this = this;
      _this.currentPage = value;
      _this.$emit("pagination", null, { page: value, limit: _this.pageSize });
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/EcPagerBar/src/pagerBar.vue